import { forwardRef, useEffect } from 'react';
import { useForwardingRef } from '@arc/frontend/util-common';
import { inputStyles } from '../Inputs';
export const Textarea = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function Textarea(props, forwardedRef) {
  const {
    error,
    archived,
    disabled,
    readOnly,
    innerStyles,
    ...other
  } = props;
  const ref = useForwardingRef(null, [forwardedRef]);

  // Expand height of textarea to remove scroll bar when readOnly
  // Adapted from https://stackoverflow.com/a/24676492
  useEffect(() => {
    const element = ref.current;
    if (readOnly && element) {
      element.style.height = `${element.scrollHeight}px`;
    }
  });
  return <textarea ref={ref} css={[inputStyles.input, disabled && inputStyles.inputContainerDisabled, archived && inputStyles.inputArchived, readOnly && inputStyles.inputReadOnly, inputStyles.inputContainer, error && inputStyles.inputContainerError, disabled && inputStyles.inputContainerDisabled, archived && inputStyles.inputContainerArchived, readOnly && inputStyles.inputContainerReadOnly, "padding:0.45rem 0.75rem;", innerStyles, process.env.NODE_ENV === "production" ? "" : ";label:Textarea;"]} disabled={disabled} readOnly={readOnly} {...other} />;
});